import axios from "axios";


export const http2022 = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT_HTTPS,
});